var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartRate2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.2967,
    cy: 40.2967,
    r: 37.7782,
    fill: "#D7D4F8",
    stroke: "#845BB3",
    strokeWidth: 5.03709
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12176_707)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2771 29.2302C37.8467 26.8099 35.3105 25.6085 32.8725 25.4272C30.1172 25.2257 27.6843 26.3439 25.9314 28.112C22.4861 31.5875 21.4333 37.8713 25.74 42.1957L25.7778 42.2309L39.4233 54.8539C39.6561 55.0698 39.962 55.1898 40.2796 55.1898C40.5972 55.1898 40.903 55.0698 41.1359 54.8539L54.7814 42.2309L54.8091 42.2032C59.1762 37.8965 58.121 31.6127 54.658 28.1371C52.9 26.3691 50.4595 25.2484 47.6992 25.4473C45.2562 25.6236 42.71 26.8149 40.2771 29.2302ZM39.4208 34.2219C39.3033 33.9485 39.1107 33.714 38.8653 33.5456C38.62 33.3772 38.3319 33.2818 38.0345 33.2705C37.7371 33.2591 37.4426 33.3323 37.1852 33.4816C36.9277 33.6308 36.7178 33.85 36.5798 34.1137L34.424 38.2315H31.5201C31.1026 38.2315 30.7022 38.3973 30.407 38.6925C30.1118 38.9877 29.946 39.3881 29.946 39.8056C29.946 40.223 30.1118 40.6234 30.407 40.9186C30.7022 41.2138 31.1026 41.3797 31.5201 41.3797H35.376C35.9628 41.3797 36.4992 41.0522 36.7712 40.5359L37.8366 38.5035L40.4634 44.5984C40.5703 44.8475 40.7398 45.0648 40.9553 45.2292C41.1709 45.3937 41.4252 45.4996 41.6938 45.5369C41.9623 45.5741 42.2359 45.5414 42.4881 45.4418C42.7403 45.3422 42.9624 45.1792 43.1331 44.9686L46.0445 41.3797H49.0718C49.4893 41.3797 49.8897 41.2138 50.1849 40.9186C50.4801 40.6234 50.6459 40.223 50.6459 39.8056C50.6459 39.3881 50.4801 38.9877 50.1849 38.6925C49.8897 38.3973 49.4893 38.2315 49.0718 38.2315H45.294C45.0597 38.232 44.8284 38.2845 44.6168 38.3851C44.4051 38.4857 44.2184 38.6319 44.07 38.8133L42.3246 40.9666L39.4182 34.2245L39.4208 34.2219Z",
    fill: "#845BB3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12176_707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.2596,
    height: 35.2596,
    fill: "white",
    transform: "translate(22.668 22.6669)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRate2);
export default __webpack_public_path__ + "static/media/heart-rate-2.612df4c4a92055b8471b5d2829790acd.svg";
export { ForwardRef as ReactComponent };